/* GutID redesign C: header, mega menus, phone menu, carousels, small helpers. No dependencies. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var desk = window.matchMedia('(min-width: 821px)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---------- header: over the hero on the homepage, fixed once scrolled ---------- */
  var hdr = doc.querySelector('[data-gidc-hdr]');
  if (hdr && hdr.classList.contains('is-over')) {
    var start = 0;
    var measure = function () { start = hdr.offsetTop + hdr.offsetHeight; };
    var onScroll = function () {
      var y = window.scrollY || 0;
      var fixed = y > start + 40;
      if (fixed !== hdr.classList.contains('is-fixed')) {
        hdr.classList.toggle('is-fixed', fixed);
        var nav = hdr.querySelector('.nav');
        if (nav) { nav.classList.toggle('over', !fixed); nav.classList.toggle('solid', fixed); }
      }
    };
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mega menus (desktop) ---------- */
  var triggers = Array.prototype.slice.call(doc.querySelectorAll('[data-mega]'));
  var scrim = doc.querySelector('[data-gidc-scrim]');
  var openKey = null, closeTimer = null, openTimer = null;
  function panel(key) { return doc.getElementById('gidc-mega-' + key); }
  function setOpen(key) {
    if (key === openKey) return;
    triggers.forEach(function (t) {
      var on = t.getAttribute('data-mega') === key;
      t.classList.toggle('open', on);
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      var p = panel(t.getAttribute('data-mega'));
      if (p) p.hidden = !on;
    });
    if (scrim) scrim.hidden = !key;
    if (hdr) hdr.classList.toggle('mega-open', !!key);
    openKey = key;
  }
  function closeSoon() { clearTimeout(openTimer); clearTimeout(closeTimer); closeTimer = setTimeout(function () { setOpen(null); }, 180); }
  function keep() { clearTimeout(closeTimer); }
  triggers.forEach(function (t) {
    var key = t.getAttribute('data-mega');
    t.addEventListener('click', function (e) {
      if (!desk.matches) return;
      e.preventDefault();
      setOpen(openKey === key ? null : key);
    });
    t.addEventListener('pointerenter', function () {
      if (!desk.matches || !fine.matches) return;
      keep(); clearTimeout(openTimer);
      openTimer = setTimeout(function () { setOpen(key); }, openKey ? 0 : 90);
    });
    t.addEventListener('pointerleave', closeSoon);
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && desk.matches) {
        e.preventDefault(); setOpen(key);
        var first = panel(key) && panel(key).querySelector('a, button');
        if (first) first.focus();
      }
    });
  });
  Array.prototype.forEach.call(doc.querySelectorAll('[data-mega-panel]'), function (p) {
    p.addEventListener('pointerenter', keep);
    p.addEventListener('pointerleave', closeSoon);
  });
  if (scrim) scrim.addEventListener('click', function () { setOpen(null); });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openKey) {
      var t = doc.querySelector('[data-mega="' + openKey + '"]');
      setOpen(null);
      if (t) t.focus();
    }
    closeMenu();
  });
  doc.addEventListener('focusin', function (e) {
    if (!openKey) return;
    if (!e.target.closest('[data-mega-panel]') && !e.target.closest('[data-mega]')) setOpen(null);
  });
  desk.addEventListener && desk.addEventListener('change', function () { setOpen(null); });

  /* ---------- phone menu ---------- */
  var menu = doc.getElementById('gidc-menu');
  var burger = doc.querySelector('[data-gidc-open-menu]');
  var lastFocus = null;
  function openMenu() {
    if (!menu) return;
    lastFocus = doc.activeElement;
    menu.hidden = false;
    root.classList.add('gidc-lock');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    var c = menu.querySelector('[data-gidc-close-menu]');
    if (c) c.focus();
  }
  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    root.classList.remove('gidc-lock');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (burger) burger.addEventListener('click', openMenu);
  Array.prototype.forEach.call(doc.querySelectorAll('[data-gidc-close-menu]'), function (b) {
    b.addEventListener('click', function () { closeMenu(); });
  });
  Array.prototype.forEach.call(doc.querySelectorAll('a[href="#gidc-menu"]'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openMenu(); });
  });
  /* tabs: for you / for clinicians */
  var tabs = Array.prototype.slice.call(doc.querySelectorAll('[data-mx-tab]'));
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (o) {
        var on = o === t;
        o.classList.toggle('on', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = doc.getElementById(o.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    });
  });
  /* focus stays inside the open menu */
  if (menu) menu.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(menu.querySelectorAll('a[href], button, input, select'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* ---------- carousels: .rctl controls drive the scroller just before them ---------- */
  Array.prototype.forEach.call(doc.querySelectorAll('.rctl'), function (ctl) {
    var sc = ctl.previousElementSibling;
    while (sc && !(sc.scrollWidth > sc.clientWidth + 4 || sc.classList.contains('mscroll'))) sc = sc.previousElementSibling;
    if (!sc) return;
    var prev = ctl.querySelector('.rbtn[aria-label^="Prev"]');
    var next = ctl.querySelector('.rbtn[aria-label^="Next"]');
    var count = ctl.querySelector('.rcount');
    var segs = ctl.querySelectorAll('.rprog span, .rdots i');
    var items = function () { return Array.prototype.filter.call(sc.children, function (c) { return c.offsetWidth > 0; }); };
    function index() {
      var its = items(); if (!its.length) return 0;
      var x = sc.scrollLeft, best = 0, bd = Infinity;
      its.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - sc.offsetLeft - x); if (d < bd) { bd = d; best = i; } });
      if (sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4) best = its.length - 1;
      return best;
    }
    function paint() {
      var i = index(), n = items().length;
      if (count) {
        var b = count.querySelector('b');
        var label = (i + 1 < 10 ? '0' : '') + (i + 1);
        if (b) b.textContent = label; else count.textContent = (i + 1) + ' / ' + n;
      }
      Array.prototype.forEach.call(segs, function (s, k) { s.classList.toggle('on', k === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    }
    function go(d) {
      var its = items(), i = Math.max(0, Math.min(its.length - 1, index() + d));
      var c = its[i]; if (!c) return;
      sc.scrollTo({ left: c.offsetLeft - sc.offsetLeft - (parseFloat(getComputedStyle(sc).scrollPaddingLeft) || 0), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var raf = 0;
    sc.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
    paint();
  });

  /* ---------- small helpers ---------- */
  /* country selector submits on change */
  Array.prototype.forEach.call(doc.querySelectorAll('[data-gidc-autosubmit]'), function (s) {
    s.addEventListener('change', function () { if (s.form) s.form.submit(); });
  });
  /* animated pieces wait until they are on screen when scroll-driven animation is not supported */
  if (!(window.CSS && CSS.supports('animation-timeline: view()')) && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    Array.prototype.forEach.call(doc.querySelectorAll('.tplot.tpv, .sigseq, .tpwrap'), function (el) { io.observe(el); });
  }
  /* "Pause animations" is remembered for the visit */
  var pm = doc.getElementById('pm');
  if (pm) {
    try { if (sessionStorage.getItem('gidc-pm') === '1') pm.checked = true; } catch (e) {}
    pm.addEventListener('change', function () { try { sessionStorage.setItem('gidc-pm', pm.checked ? '1' : '0'); } catch (e) {} });
  }
  /* the cart count follows add-to-cart events from any form on the page */
  doc.addEventListener('gidc:cart', function (e) {
    var n = e.detail && e.detail.count;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-gidc-count]'), function (b) { b.textContent = n; b.hidden = !n; });
  });
})();
